import { useEffect, RefObject } from 'react'
import type { MapRef } from 'react-map-gl'
import type MapboxDraw from '@mapbox/mapbox-gl-draw'

interface UseMapLifecycleParams {
  mapRef: RefObject<MapRef | null>
  drawRef: RefObject<MapboxDraw | null>
}

export function useMapLifecycle({ mapRef, drawRef }: UseMapLifecycleParams) {
  // Cleanup: Remove draw control when component unmounts
  useEffect(() => {
    const map = mapRef.current?.getMap()
    const draw = drawRef.current
    return () => {
      if (map && draw) {
        map.removeControl(draw)
        drawRef.current = null
      }
    }
  }, [mapRef, drawRef])
}
